<mat-expansion-panel [expanded]="openExpansionPanel$ | async">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'LIB_ORDERS.COMMON.ACTIVITY.TITLE' | translate }}
    </mat-panel-title>
    <mat-panel-description>
      <ng-container *ngIf="orderCreatedByInfo$ | async as createdByInfo">
        <span *ngIf="createdByInfo?.name as name">
          {{ 'LIB_ORDERS.COMMON.ACTIVITY.CREATED_BY' | translate: { name: name } }}
        </span>
        <va-badge color="{{ createdByInfo?.color }}">
          {{ createdByInfo?.translationKey | translate }}
        </va-badge>
      </ng-container>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-container *ngFor="let info of orderDetailFields$ | async">
    <ng-container
      *ngTemplateOutlet="info.childFields.length ? multiStep : singleStep; context: { info: info }"
    ></ng-container>
    <ng-template #multiStep let-info="info">
      <mat-accordion [multi]="true">
        <mat-expansion-panel class="no-styling" [expanded]="openExpansionPanel$ | async">
          <mat-expansion-panel-header [collapsedHeight]="'*'" [expandedHeight]="'auto'">
            <ng-container *ngTemplateOutlet="singleStep; context: { info: info }"></ng-container>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let child of info.childFields">
            <ng-container
              *ngTemplateOutlet="singleStep; context: { info: child, isChild: true, compact: true }"
            ></ng-container>
            <mat-divider></mat-divider>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-template>
    <ng-template #singleStep let-info="info" let-isChild="isChild" let-compact="compact">
      <div class="order-details__list-item row" [ngClass]="{ compact: compact }">
        <div class="detail-left-col">
          {{ buildDetailName(info, isChild) | translate }}
        </div>
        <div class="order-details__list-item__value show-line-breaks">
          {{ buildDetailValue(info) }}
        </div>
      </div>
    </ng-template>
  </ng-container>
  <agreements [order]="order" [salesOrderUsers$]="orderUsers$" [openExpansionPanel$]="openExpansionPanel$"></agreements>
</mat-expansion-panel>
